import styled, { createGlobalStyle } from 'styled-components';
import { useEffect, useState } from "react";
import 'handsontable/styles/handsontable.min.css';
import 'handsontable/styles/ht-theme-main.min.css';
import Handsontable from 'handsontable/base';
import { registerAllModules } from 'handsontable/registry';
import { HotTable } from '@handsontable/react-wrapper';
import { ContextMenu } from "handsontable/plugins";
import { registerRenderer, textRenderer } from "handsontable/renderers";
import { v4 as uuidv4 } from 'uuid';
import CustomBlockButton from '../../../../../../../../../../../components/button/CustomBlockButton';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu';
import CustomSmallButton from '../../../../../../../../../../../components/button/CustomSmallButton';


registerAllModules();

const GlobalStyle = createGlobalStyle`
  .htContextMenu,
  .handsontable .context-menu-list {
    z-index: 1500 !important;
  }
`;

const StyledContainer = styled.div`
    h2{
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 5px;
    }

    .footer{
        display: flex;
        gap: 10px;
        margin-top: 10px;
    }
`;

registerRenderer('customHotTableNewRenderer', (hotInstance, TD, ...rest) => {
    textRenderer(hotInstance, TD, ...rest);
    TD.style.fontWeight = 'bold';
    TD.style.color = 'green';
    TD.style.background = '#d7f1e1';
});

export function FragmentItemsCheckStep({
    editableItems,
    onClearExistedItems,
    onNextStep,
    onPrevToDefault
}) {
    return (
        <>
            <GlobalStyle />
            <StyledContainer>
                <h2>미리보기</h2>
                <div className='mb-2'>
                    <CustomSmallButton
                        type='button'
                        onClick={() => { onClearExistedItems(); }}
                    >
                        기존제품비우기
                    </CustomSmallButton>
                </div>
                <div className="ht-theme-main-dark-auto">
                    <HotTable
                        data={editableItems}
                        rowHeaders={true}
                        colHeaders={HEADERS.map(header => header.label)}
                        width="100%"
                        height="300px"
                        autoWrapRow={true}
                        autoWrapCol={true}
                        hiddenColumns={{
                            columns: [0, 6],
                            // indicators: true,
                        }}
                        cell={
                            editableItems?.reduce((acc, item, index) => {
                                HEADERS.forEach((header, colIndex) => {
                                    if (item?.isNew) {
                                        acc.push({
                                            row: index,
                                            col: colIndex,
                                            renderer: 'customHotTableNewRenderer',
                                        });
                                    }
                                });
                                return acc;
                            }, [])
                        }
                        contextMenu={true}
                        readOnly={false}
                        // afterChange={(changes, source) => {
                        //     console.log(changes)
                        //     if (!changes || source === 'loadData') return;
                        //     setEditableItems(prev => {
                        //         const copy = [...prev];
                        //         changes.forEach(([row, prop, oldVal, newVal]) => {
                        //             copy[row][prop] = newVal;
                        //         });
                        //         return copy;
                        //     });
                        // }}
                        licenseKey="non-commercial-and-evaluation" // for non-commercial use only
                    />
                </div>
                <div className='footer'>
                    <CustomBlockButton
                        type='button'
                        onClick={() => onPrevToDefault()}
                    >
                        <div className='flex items-center gap-2'>
                            <LuChevronLeft /> <span>이전단계</span>
                        </div>
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        onClick={() => onNextStep()}
                        style={{ background: '#333', color: '#fff' }}
                    >
                        <div className='flex items-center gap-2'>
                            <span>다음단계</span> <LuChevronRight />
                        </div>
                    </CustomBlockButton>
                </div>
            </StyledContainer>
        </>
    );
}

const HEADERS = [
    {
        key: 'uuid',
        label: 'UUID'
    },
    {
        key: 'productName',
        label: '상품명'
    },
    {
        key: 'optionName',
        label: '옵션명'
    },
    {
        key: 'boxQuantity',
        label: '박스수량'
    },
    {
        key: 'productQuantity',
        label: '예상상품수량'
    },
    {
        key: 'optionCode',
        label: '옵션코드'
    },
    {
        key: 'isNew',
        label: '신규여부',
    }
];